import React from 'react';
import PropTypes from 'prop-types';
import { InputWrapper, InputLabel } from './Styled';

class Textfield extends React.Component {
  render() {
    const { id, label, type } = this.props;
    return (
      <div>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <InputWrapper type={type || 'text'} {...this.props} />
      </div>
    );
  }
}

Textfield.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string
};

export default Textfield;
